import React, { useState, forwardRef, useImperativeHandle } from "react";

const TransactionRenderer = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value);

    const canceledSpan = props.node.data
        ? props.node.data.posTransaction?.voided
            ? <span className="canceled-payment">{value}</span>
            : <>{value}</>
        : <></>;

    useImperativeHandle(ref, () => ({
        refresh(params) {
            const val = params.value;
            if (val != undefined) {
                setValue(val);
            }
            return true;
        }
    }));

    return <span>{value ? canceledSpan : <></>}</span>;
});

export default TransactionRenderer;
